import React, { useContext } from 'react';
import Dashboard from './pages/Dashboard.jsx';
import Courses from './pages/Courses.jsx';
import Groups from './pages/Groups.jsx';
import Login from './pages/Login.jsx';
import CourseDetails from './pages/CourseDetails.jsx';
import StartCoursePage from './pages/StartCoursePage.jsx';
import Users from './pages/Users.jsx';
import Quiz from './pages/Quiz.jsx';
import StartQuiz from './pages/StartQuiz.jsx';
import Questions from './pages/QuizQuestions.jsx';
import UserGroup from './pages/UserGroup.jsx';
import Reports from './pages/Reports.jsx';
import CourseReport from './pages/CourseReport.jsx';
import LMSDashboard from './pages/LMSDashboard.jsx';
import About from './pages/About.jsx';
import PrivateRoute from './components/Auth/PrivateRoute.jsx';
import { createBrowserRouter } from 'react-router-dom';
import { RouterProvider } from 'react-router-dom';
import { AuthContext } from './hooks/AuthContext.js';

const routesDefinition = createBrowserRouter(
  [
    {
      path: '/',
      element: <Login />,
      index: true
    },
    {
      element: <PrivateRoute />,
      children: [
        {
          index: true,
          path: '/home',
          element: <Dashboard />
        },
        {
          path: '/about',
          element: <About />
        },
        {
          path: '/users',
          element: <Users />
        },
        {
          path: '/quiz',
          element: <Quiz />
        },
        {
          path: '/quiz-questions/:quizid',
          element: <Questions />
        },
        {
          path: '/startquiz/:courseid',
          element: <StartQuiz />
        },
        {
          path: '/usergroup',
          element: <UserGroup />
        },
        {
          path: '/groups',
          element: <Groups />
        },
        {
          path: '/courses',
          element: <Courses />
        },
        {
          path: '/courses/:id',
          element: <CourseDetails />
        },
        {
          path: '/startcoursepage/:id',
          element: <StartCoursePage />
        },
        {
          path: '/coursereport/:id',
          element: <CourseReport />
        },
        {
          path: '/reports',
          element: <Reports />
        },
         {
          path: '/dashboard',
          element: <LMSDashboard />
        },
      ]
    },
    {
      path: '*',
      element: <p>404 Error - Nothing here...</p>
    }
  ], 
//{
//   basename: process.env.REACT_APP_BaseName,
// }
);


function AppRouting() {
  const { isLoading } = useContext(AuthContext);
  if (isLoading) return (<></>)

  return (<RouterProvider router={routesDefinition} />)
}

export default AppRouting;


